import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () =>
      import('./home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'about-us',
    loadComponent: () =>
      import('./about-us/about-us.component').then((m) => m.AboutUsComponent),
  },
  {
    path: 'features',
    loadComponent: () =>
      import('./features/features.component').then((m) => m.FeaturesComponent),
  },
  {
    path: 'security',
    loadComponent: () =>
      import('./security/security.component').then((m) => m.SecurityComponent),
  },
  {
    path: 'help',
    loadComponent: () =>
      import('./help/help.component').then((m) => m.HelpComponent),
  },
  {
    path: 'career',
    loadComponent: () =>
      import('./career/career.component').then((m) => m.CareerComponent),
  },
  {
    path: 'kyc-flow',
    loadComponent: () =>
      import('./kyc-flow/kyc-flow.component').then((m) => m.KycFlowComponent),
  },
  {
    path: 'contact-us',
    loadComponent: () =>
      import('./contact-us/contact-us.component').then(
        (m) => m.ContactUsComponent
      ),
  },
];

export class AppRoutingModule {}

/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/
